import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonHeader, IonFooter, IonContent } from '@ionic/react';
import ReactDOM from 'react-dom';


import { ShowProductPicsModal } from './Modal_ShowProductPics';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { ViewInvoiceModal } from '../../../zInternal_Features/merchant/components/Modal_ViewInvoice';

import '../../../../css/qavaApp.css';


export function Modal_RecipeList (props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [menuType, setMenuType] = useState(null);
    let [productID, setProductID] = useState(null);

    let [viewIonPopover, setvViewIonPopover] = useState(false);

    
    let [viewInventoryAvailableProducts, setViewInventoryAvailableProducts] = useState([]);
    
    
    useEffect(() => {

        const requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    Tracker: '74301_productList_restaurant',
                    user: acctID,
                    xStartDateRange: authenticatedMerchent_context.startDate,
                    xEndDateRange: authenticatedMerchent_context.endDate,
                    sessionID: sessionID,
                }),
            };
    
            fetch(baseURL + 'hotel_merchantAcct_argsjqApp', requestOptions)
                .then(res => res.text())
                .then(res => {
                    let rows = res.toString().split('~~~');
    
                    for (let rownum = 0; rownum < rows.length - 1; ++rownum) {
                        let cols = rows[rownum].split('|');
    

                        setViewInventoryAvailableProducts((prevAvailableProducts) => {
                            return prevAvailableProducts.concat({
                                productID: cols[0],
                                itemID_list: cols[1],
                                productType: cols[2],
                                productName: cols[3],
                                productPartNum: cols[4],
                                productPhoneNumber: cols[5],
                                productCostPerUnit: parseFloat(cols[6]).toFixed(2),
                                productSalePrice: parseFloat(cols[7]).toFixed(2),
                                productPic1: cols[8],
                                productPic2: cols[9],
                                productPic3: cols[10],
                                productPic4: cols[11],
                                productDateCreated: cols[12],
                                productAddedBy: cols[13],
                                productIsActivated: cols[14],


                            });
                        });
                    }
                });
    }, []);

    function activateRecipe()
    {
        
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: '74300_activateRecipe',
                user: acctID,
                xProductID: productID,
                xMenuType: menuType,
                sessionID: sessionID,
            })

            
        }

    
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
            // alert(window.location.pathname)

           // let rows = res.toString().split('~~~');
           // let rowLength = rows.length
            
                
        })

    }
    
    function closeModalHandler(event) {
        setViewInventoryAvailableProducts([]);
        props.closeModal(event);
    }
    function popOverHandler(event)
    {
        alert("in popoover handler");
        alert(event);

        setProductID(event[1]);
        alert(event);

        setvViewIonPopover(true);
    }

    function popOverSelection(event) {

        alert(event);

        setMenuType(event);
        setvViewIonPopover(false);
    }
    
    return (
        <React.Fragment>
                    
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonContent className='grid_content'>
                    <IonGrid >
                            <IonRow>
                                <IonCol size="12">
                                    <h3> Restaurant Product List </h3>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol size='2'>
                                    <h3> ID </h3>
                                </IonCol>
                                <IonCol size='2'>
                                    <h3> Name </h3>
                                </IonCol>
                                <IonCol size='5'>
                                    <h3> Total </h3>
                                </IonCol>
                                <IonCol size='3'>
                                    <h3> Action </h3>
                                </IonCol>
                            </IonRow>
                            {viewInventoryAvailableProducts.map((detailData) => {
                                return (
                                    <IonRow key={detailData.productID}>
                                        <IonCol size='2'>{detailData.productID}</IonCol>
                                        <IonCol size='2'>{detailData.productName}</IonCol>
                                        <IonCol size='5'>{detailData.productSalePrice}</IonCol>
                                        <IonCol size='3'>
                                            <IonButton onClick={() => popOverHandler([true, detailData.productID])}>Add</IonButton>
                                            <IonButton>Details</IonButton>
                                        </IonCol>
                                    </IonRow>
                                );
                            })}
                        </IonGrid>

                        {viewIonPopover == true && (
                            <div
                            style={{
                            position: 'absolute',
                            width: '75%',
                            height: '50%',
                            backgroundColor: 'white',
                            transform: 'translate(10%, 0%)',
                            padding: '16px',
                            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                            zIndex: 1000,
                            borderRadius: '8px',       /* Rounded corners */
                            border: '2px rgb(0, 0, 0) solid',
                            }}
                            >

                            <IonGrid>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <IonText>SELECT MENU TYPE</IonText>
                                        </IonCol>
                                        <IonCol size='6'>
                                        <select name="paymenttype" id='paymenttype' onChange={(e) => popOverSelection(e.target.value) }>
                                            <option value='null' selected='selected'>Make Selection</option>
                                            <option value='food' >Food</option>
                                            <option value='drinks'>Drinks</option>
                                        </select>
                                        </IonCol>
                                    </IonRow>

                            </IonGrid>
                            </div>
                            )}   
            </IonContent>
            <IonFooter class='appFooter'>
                <IonGrid>
                    <IonRow>
                        <IonCol size="6">
                            <IonButton onClick={() => activateRecipe()}>Submit </IonButton>
                        </IonCol>
                        <IonCol size="6">
                            <IonButton onClick={() => closeModalHandler()}>Cancel </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>
        </IonModal>
        ) : null}
    
        </React.Fragment>

    )
}